import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import TabsComponent from '../tabs-new';
import { NAV_HEIGHT } from './constants';

export const Tabs = styled(TabsComponent)`
  position: sticky;
  top: ${layout.headerHeight.desktop.rem};
  background: ${p => p.theme.bg.primary};
  z-index: 2;
  height: ${`${NAV_HEIGHT}px`};

  ${media.mediumUp`
    margin: 0 ${layout.spacing.xSmall};
  `}

  ${media.smallOnly`
    top: ${layout.headerHeight.mobile.rem};
  `};
`;
